// extracted by mini-css-extract-plugin
export default {"flexWrapper":"Pages_flexWrapper__TERWn","content":"Pages_content__9sU4S"};